export type PopulateFaqProps = {
  question: string;
  answer: any;
  id: string;
};
/**
 *
 * @param props - Takes the {question,answer,key} as inputs
 * @type - PopulateFaqProps
 * @returns - Populated data of faqs passed through props
 */
export const FaqItem = (props: PopulateFaqProps) => {
  const { question, answer, id } = props;
  return (
    <div className="faq">
      <div
        className="faq__header collapsed"
        data-toggle="collapse"
        data-target={`#${id}`}
      >
        <p
          className="m-0"
          //  style={{ margin: 0 }}
        >
          {question}
        </p>
        <span></span>
      </div>
      <div className="faq__answer collapse" id={id}>
        <p
          className="m-0"
          // style={{ margin: 0 }}
        >
          {answer}
        </p>
      </div>
    </div>
  );
};
